import React, { Component } from 'react';

import { GenericSimpleToggleButton } from 'com-gyf-webcore-userinterfacecomponents';

import ListaPerfil from './ListaPerfil.jsx';

class TableRow extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidMount() {
        //this.props.getScreenData(this.props.currentScope);
        $('[data-toggle="tooltip"]').tooltip();
    }

    render() {
        let props = this.props;
        let codigoPerfil = "", textoTooltip = "";
        let funciones = (props.perfil.first && !props.activate) ?
            <label className="left-separator-xxs bottom-separator-xxs">
                Por favor seleccione producto, categoría y programa para ver los permisos
        </label> : "";

        if (props.perfil.functions) {
            if (props.perfil.functions.length > 0) {
                let ProfileId = props.perfil.Id;
                funciones = props.perfil.functions.map(function (func) {
                    return (
                        <GenericSimpleToggleButton text={func.Codigo}
                            buttonType="btn btn-tag btn-tag-secondary not-clickable" />
                    );
                });
            }
        }

        let lengthHasta = props.perfil.Codigo == props.perfil.Codigo.toUpperCase ? 15 : 19;
        let cortarCaracterHasta = props.perfil.Codigo == props.perfil.Codigo.toUpperCase ? 12 : 16;

        if (props.perfil.Codigo.length >= lengthHasta) {
            textoTooltip = props.perfil.Codigo;
            codigoPerfil = props.perfil.Codigo.substr(0, cortarCaracterHasta) + "...";
        } else {
            codigoPerfil = props.perfil.Codigo;
        }

        return (
            <tr>
                <td className="td-dropdown">
                    <div className="dropdown">
                        <button className="btn btn-default dropdown-toggle" style={{ width: '220px' }} type="button" data-toggle="dropdown" id={props.perfil.Id}>
                            <div className="row">
                                <div className="col-xs-10">
                                    {textoTooltip != "" ?
                                        <p style={{ whiteSpace: 'normal' }} data-toggle="tooltip" data-placement="top" title={textoTooltip} >
                                            {codigoPerfil}
                                        </p>
                                        :
                                        <div style={{ whiteSpace: 'normal' }}>
                                            <p>{codigoPerfil}</p>
                                        </div>
                                    }
                                </div>
                                <div className="col-xs-2">
                                    <span className="ti-angle-down"></span>
                                </div>
                            </div>
                        </button>
                        <ListaPerfil id={props.perfil.Id}
                            functions={props.functions}
                            setPerfilEdicion={props.setPerfilEdicion}
                            setInfoPerfilToDelete={props.setInfoPerfilToDelete}
                            gruposWindows={props.perfil.gruposWindows} />
                    </div>
                </td>
                <td colSpan="4" className="left-separator">
                    {funciones}
                </td>
            </tr>
        );
    }
}


export default TableRow;